import { Link } from 'react-router-dom';

const conditions = [
  'давать перспективным сотрудникам более сложные задачи;',
  'развивать ответственность;',
  'передавать часть функций;',
  'давать возможность принимать решения;',
  'развивать коммуникацию;',
  'обучать обратной связи;',
  'развивать навыки управления;',
  'давать опыт взаимодействия с другими подразделениями;',
  'постепенно готовить к будущей роли.',
];

export default function TalentPool() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Наставничество и кадровый резерв
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Кадровый резерв — это не просто список сотрудников с высоким потенциалом. Чтобы из перспективного специалиста вырос руководитель, необходимо создавать условия для развития:
        </p>

        <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {conditions.map((c, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-seedling-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{c}</span>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Наставничество напрямую связано с подготовкой будущих руководителей. Развитие управленческих навыков — задача кластера{' '}
            <Link to="/menedzhment-i-liderstvo" className="underline cursor-pointer">«Менеджмент и лидерство»</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}